import React, { useState, useEffect } from "react";
import Main from "../components/Main/Main";


const MainPage = () => {
    
    const [message, setMessage] = useState("");

  useEffect(() => {
    setMessage("Willkommen zum JUGEND GRÜNDET Planspiel!");
  }, []);

    return (
        <div>
            <Main/>
            
        </div>
    )
}

export default MainPage;